module.exports = {"definitions":[],"scratch":{"id":"id_block_897433_1","inputs":[],"steps":[{"id":"id_graph_897433_69","stepType":"graph","nodes":{"id_node_897433_70":{"id":"id_node_897433_70","name":""}},"calls":{"id_call_897433_71":{"id":"id_call_897433_71","callType":"code","inputs":[],"code":"[{first: \"Josh\", last: \"Horowitz\"}\n,{first: \"David\", last: \"Attenborough\"}]","outputs":[{"outside":"id_node_897433_70"}],"collapsed":true}}}]},"name":"names"}


//////////////////
// WEBPACK FOOTER
// ./src/examples/names blank.json
// module id = 384
// module chunks = 0